import React from "react";

import { useAppSelector } from "../../../app/store";
import { ErrorDisplay } from "../../../components/ui/error/ErrorDisplay";
import { CustomLoadingSpinner } from "../../../components/ui/spinners/LoadingSpinner";
import { RETRIEVING_DATA_SUBTITLE } from "../../../lib/constants";
import ProfileIdentityAccordionContent from "../../analysis/components/ProfileIdentityAccordion";
import InterviewFindingsAccordionContent from "../../analysis/components/InterviewFindingsAccordion";
import AdditionalAnalysisAccordionContent from "../../analysis/components/AdditionalAnalysisAccordion";
import { isCreditAreaOfFraud, isCyberAreaOfFraud, isOperationalAreaOfFraud, selectCaseHeaderLoadingStatus } from "../../caseinfo/logic/Slice";
import {
  isIdentityProfileVerificationsV2Enabled,
  isLegalTechnicalAnalysisV2Enabled,
} from "../../configs/logic/Slice";
import CustomerVerificationsTab from "../../customerVerifications/components/CustomerVerificationsTab";
import LegalTechnicalAnalysisContent from "../../legalTechnicalAnalysis/components/LegalTechnicalAnalysisTab";
import WorkbenchTabs, { WorkbenchTab } from "./WorkbenchTabs";

const FactFindingTabs: React.FC = () => {
  const caseInfoLoadingStatus = useAppSelector(selectCaseHeaderLoadingStatus);
  const isCreditFraud = useAppSelector(isCreditAreaOfFraud);
  const isOperationalFraud = useAppSelector(isOperationalAreaOfFraud);
  const isCyberFraud = useAppSelector(isCyberAreaOfFraud);

  const legalTechnicalAnalysisEnabled = useAppSelector(
    isLegalTechnicalAnalysisV2Enabled,
  );
  const identityProfileVerificationsV2Enabled = useAppSelector(
    isIdentityProfileVerificationsV2Enabled,
  );

  if (caseInfoLoadingStatus === "pending") {
    return (
      <CustomLoadingSpinner
        title="Loading Case Analysis..."
        subtitle={RETRIEVING_DATA_SUBTITLE}
        minHeight="min-h-[400px]"
      />
    );
  }

  if (caseInfoLoadingStatus === "failed") {
    return (
      <ErrorDisplay
        error="Failed to load case analysis."
        showRetryButton={false}
      />
    );
  }

  const tabs: WorkbenchTab[] = [];

  if(isCreditFraud || isOperationalFraud) {
    tabs.push({
      key: "document-profile-verification",
      label: "Document & Profile Verification",
      content: identityProfileVerificationsV2Enabled ? (
        <CustomerVerificationsTab />
      ) : (
        <ProfileIdentityAccordionContent />
      ),
    })
  }

  if (isCreditFraud && legalTechnicalAnalysisEnabled) {
    tabs.push({
      key: "legal-technical-analysis",
      label: "Legal & Technical Analysis",
      content: <LegalTechnicalAnalysisContent />,
    });
  }

  if(isCreditFraud || isOperationalFraud) {
    tabs.push({
      key: "interview-findings",
      label: "Interviews & Site Visits",
      content: <InterviewFindingsAccordionContent />,
    })
  }

  if(isOperationalFraud || isCyberFraud) {
    tabs.push(
      {
        key: "other-analysis",
        label: "Other Analysis",
        content: <AdditionalAnalysisAccordionContent />,
      },
    );
  }

  return (
    <WorkbenchTabs
      tabs={tabs}
      contentCardClassName="border border-gray-100 shadow-overviewCard rounded-b-xl bg-white overflow-hidden"
      contentWrapperClassName="p-4 min-w-0"
    />
  );
};

export default FactFindingTabs;
